module.exports = __webpack_public_path__ + "static/media/mango.36fd6555.png";